/**
 * The top bar: menu (mobile), brand (mobile), open-report tabs, and the signed-in user.
 * Uses the lighter shell-top surface — sidebar stays dark charcoal.
 */

import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Brand } from '@/components/layout/Brand';
import { ReportTabs } from '@/components/layout/ReportTabs';
import { UserMenu } from '@/components/layout/UserMenu';
import { Button } from '@/components/ui/button';
import { useI18n } from '@/lib/i18n';

export function AppHeader({ onOpenMenu }: { onOpenMenu: () => void }) {
  const { t } = useI18n();
  return (
    <header className="sticky top-0 z-30 flex h-12 shrink-0 items-center gap-2 border-b border-shell-top-border bg-shell-top px-3 text-shell-top-foreground sm:px-4">
      <Button
        variant="ghost"
        size="icon"
        aria-label={t('common.openMenu')}
        onClick={onOpenMenu}
        className="shrink-0 text-shell-top-foreground hover:bg-shell-top-hover hover:text-shell-top-foreground lg:hidden"
      >
        <FontAwesomeIcon icon={faBars} aria-hidden />
      </Button>

      {/* The sidebar already carries the wordmark on desktop; repeating it wastes the row. */}
      <Brand className="shrink-0 lg:hidden" />

      <ReportTabs />

      <div className="ms-auto shrink-0">
        <UserMenu />
      </div>
    </header>
  );
}
